import { OpportunityCreator } from 'components/opportunities/OpportunityCreator'
import { OpportunityForms } from 'components/opportunities/OpportunityForms'
import React, { Fragment } from 'react'

interface AccountOpportunitiesProps {
  accountId: string
}

const AccountOpportunities: React.FC<AccountOpportunitiesProps> = ({ accountId }) => {
  return (
    <Fragment>
      <OpportunityCreator accountId={accountId} />
      <OpportunityForms accountId={accountId} />
    </Fragment>
  )
}

export { AccountOpportunities }
